// Keyword sets shared by the tokenizer (`tokenizer.ts`) and downstream
// consumers (context derivation, procedural-locals extraction). Kept in one
// place so adding a reserved word in any consumer doesn't drift the others.

export const SQL_KEYWORDS: ReadonlySet<string> = new Set([
  'WITH',
  'SELECT',
  'FROM',
  'WHERE',
  'GROUP',
  'BY',
  'HAVING',
  'ORDER',
  'LIMIT',
  'OFFSET',
  'TOP',
  'FETCH',
  'FIRST',
  'NEXT',
  'ONLY',
  'ROW',
  'ROWS',
  'TIES',
  'PERCENT',
  'JOIN',
  'INNER',
  'LEFT',
  'RIGHT',
  'OUTER',
  'FULL',
  'CROSS',
  'NATURAL',
  'ON',
  'USING',
  'INSERT',
  'INTO',
  'VALUES',
  'UPDATE',
  'SET',
  'DELETE',
  'RETURNING',
  'MERGE',
  'AS',
  'IN',
  'EXISTS',
  'ANY',
  'ALL',
  'LATERAL',
  'APPLY',
  'UNION',
  'INTERSECT',
  'EXCEPT',
  'AND',
  'OR',
  'NOT',
  'BETWEEN',
  'LIKE',
  'IS',
  'NULL',
  'RECURSIVE',
  'MATERIALIZED',
  'OUTPUT',
]);

/**
 * Set of keywords that, when they appear immediately before `(`, mark the
 * paren as opening a *fresh* subquery scope (the inside is or will be a
 * SELECT statement). Anything else (e.g. `VALUES (`, `INTO t (col list)`,
 * function arguments) inherits the parent frame's clause instead.
 */
export const SUBQUERY_OPENING_KEYWORDS: ReadonlySet<string> = new Set([
  'FROM',
  'JOIN',
  'IN',
  'EXISTS',
  'ANY',
  'ALL',
  'LATERAL',
  'APPLY',
  'AS',
  'UNION',
  'INTERSECT',
  'EXCEPT',
]);
